/*
 * VÖRR | Compra rápida (desktop + mobile) — revisado 25-09-2026
 *
 * 1. Sem listener por botão: tudo por delegação no document (funciona em carrosséis,
 *    infinite scroll e seções recarregadas).
 * 2. Corrigido o bug do clone: o script inline de cada card clonava todos os botões
 *    e o clone ficava sem listener (botão "morto" no mobile).
 * 3. Toque/arrasto em cima da compra rápida não é mais repassado ao carrossel
 *    (slider-grid) nem ao card, que engoliam o clique na home.
 * 4. Formulários no padrão do add-to-cart nativo do tema -> o tema adiciona e abre o
 *    carrinho lateral. Se o tema não interceptar o envio, entra um fallback AJAX
 *    (/cart/add.js) que leva o cliente ao carrinho.
 * 5. (15-10-2026) Clique na compra rápida ANTES do script do tema (bundle.js) terminar de
 *    carregar (comum no 1º clique logo que a página abre, principalmente no celular): antes caía
 *    direto no fallback e levava o cliente para a página /cart, sem carrinho lateral. Agora espera
 *    o tema ficar pronto (até 4s) e reenvia o mesmo formulário -> o tema adiciona e abre o carrinho
 *    lateral, igual aos demais cliques. Se o tema não ficar pronto a tempo, o fallback continua valendo.
 * 6. (29-10-2026 [AJUSTES BLACK FINAIS]) Foto da compra rápida (principalmente dentro do carrinho) demorava
 *    para aparecer: a foto do modal era "lazy" (o navegador só começava a baixar depois de o modal abrir) e
 *    vinha no tamanho original. Agora: (a) a foto já carregada no card aparece NA HORA no modal; (b) a versão
 *    nítida (480px) começa a baixar no toque, antes do clique terminar, e troca sem piscar quando chega;
 *    (c) carregamento imediato e prioritário; (d) cards do carrinho (horizontais/verticais) também reconhecidos.
 */
(function () {
  'use strict';
  if (window.__vqaReady) return;
  window.__vqaReady = true;

  var MODAL_ID = 'quick-add-modal-mobile';
  var ZONE = '.quick-add-container, .quick-add-mobile-btn';
  var TRIGGER = '[data-vqa-open], .quick-add-mobile-btn';
  var CARD = 'product-card, .product-card, .horizontal-product-card, .vertical-product-card';
  var IMG_W = 480;

  function rootUrl() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || rootUrl() + 'cart/add';
  }
  function cartUrl() {
    return (window.routes && window.routes.cart_url) || rootUrl() + 'cart';
  }
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function closest(el, selector) {
    return el && el.closest ? el.closest(selector) : null;
  }
  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  /* 29-10: fotos da compra rápida */
  // URL da foto do CDN da Shopify no tamanho do modal (480px). Outras URLs ficam como estão.
  function sized(url) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.href);
      var isCdn = /cdn\.shopify\.com$/i.test(u.hostname) || u.pathname.indexOf('/cdn/shop/') !== -1;
      if (!isCdn || /_\d*x\d*\.[a-z]+$/i.test(u.pathname)) return u.toString();
      u.searchParams.set('width', String(IMG_W));
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      return u.toString();
    } catch (e) {
      return url;
    }
  }
  function cardImage(trigger) {
    var card = closest(trigger, CARD);
    return card ? card.querySelector('img[data-main-media], img') : null;
  }
  // { now: foto que já está na tela (cache), full: versão nítida do modal }
  function photoFor(trigger) {
    var img = cardImage(trigger);
    var now = img && img.complete && img.naturalWidth ? (img.currentSrc || img.src || '') : '';
    var base = trigger.getAttribute('data-image') || (img ? (img.currentSrc || img.src || '') : '');
    return { now: now, full: sized(base) };
  }
  var warmed = {};
  function warm(url) {
    if (!url || warmed[url]) return;
    warmed[url] = true;
    var pre = new Image();
    pre.decoding = 'async';
    try { pre.fetchPriority = 'high'; } catch (e) {}
    pre.src = url;
  }

  /* 1) Isola a compra rápida do carrossel e do card */
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (closest(event.target, ZONE)) event.stopPropagation();
      // 29-10: começa a baixar a foto do modal já no toque
      var t = closest(event.target, TRIGGER);
      if (t && !closest(t, '#' + MODAL_ID)) {
        try { warm(photoFor(t).full); } catch (e) {}
      }
    }, { capture: true, passive: true });
  });

  /* 2) Modal mobile */
  function readVariants(trigger) {
    var node = trigger.querySelector('script[data-vqa-variants]');
    if (node) {
      try { return JSON.parse(node.textContent) || []; } catch (e) {}
    }
    if (trigger.dataset && trigger.dataset.product) {
      try {
        var legacy = JSON.parse(trigger.dataset.product);
        return (legacy.variants || []).map(function (v) {
          return { id: v.id, available: v.available, size: (v.options || [])[0] };
        });
      } catch (e) {}
    }
    return [];
  }

  function formHtml(productId, variant) {
    var label = variant.size || 'Único';
    return (
      '<product-form class="product-form product-form-mobile vqa-form" data-product-id="' + esc(productId) + '" id="product-form-component-' + esc(productId) + '-vqam-' + esc(variant.id) + '">' +
        '<form method="post" action="' + esc(cartAddUrl()) + '" id="vqa-mform-' + esc(variant.id) + '" accept-charset="UTF-8" enctype="multipart/form-data" novalidate="novalidate" class="shopify-product-form shopify-product-form-mobile vqa-form__form" data-type="add-to-cart-form">' +
          '<input type="hidden" name="form_type" value="product">' +
          '<input type="hidden" name="utf8" value="\u2713">' +
          '<input type="hidden" name="id" value="' + esc(variant.id) + '" data-product-form-variant>' +
          '<input type="hidden" name="quantity" value="1">' +
          '<button type="submit" name="add" class="size-option size-option-mobile" data-size-option aria-label="Adicionar ' + esc(label) + ' ao carrinho">' +
            '<span class="size-option__label">' + esc(label) + '</span>' +
            '<span class="vqa-sr" data-button-text></span>' +
            '<span class="size-option__loader" aria-hidden="true"></span>' +
            '<span class="loading-spinner btn__loading-spinner vqa-spinner" aria-hidden="true"></span>' +
          '</button>' +
        '</form>' +
      '</product-form>'
    );
  }

  var closeTimer = null;

  function open(trigger) {
    var modal = getModal();
    if (!modal || !trigger) return;
    clearTimeout(closeTimer);

    var productId = trigger.getAttribute('data-product-id') || '';
    var title = trigger.getAttribute('data-product-title') || '';
    if ((!productId || !title) && trigger.dataset && trigger.dataset.product) {
      try {
        var legacy = JSON.parse(trigger.dataset.product);
        productId = productId || legacy.id;
        title = title || legacy.title;
      } catch (e) {}
    }

    var photo = photoFor(trigger);

    var titleEl = modal.querySelector('.product-title-modal');
    if (titleEl) titleEl.textContent = title.length > 40 ? title.slice(0, 40) + '...' : title;

    var imgEl = modal.querySelector('.product-image');
    if (imgEl) {
      imgEl.loading = 'eager';
      imgEl.decoding = 'async';
      try { imgEl.fetchPriority = 'high'; } catch (e) {}
      var first = photo.now || photo.full;
      imgEl.__vqaWant = photo.full;
      if (first) {
        imgEl.src = first;
        imgEl.style.visibility = '';
        // 29-10: troca pela versão nítida só quando ela já chegou (sem piscar)
        if (photo.full && photo.full !== first) {
          var up = new Image();
          up.decoding = 'async';
          up.onload = function () {
            if (imgEl.__vqaWant === photo.full) imgEl.src = photo.full;
          };
          up.src = photo.full;
        }
      } else {
        imgEl.removeAttribute('src');
        imgEl.style.visibility = 'hidden';
      }
      imgEl.alt = title || 'Imagem do produto';
    }

    var seen = {};
    var list = [];
    readVariants(trigger).forEach(function (v) {
      if (!v || !v.available || !v.id) return;
      var key = String(v.size || 'Único');
      if (seen[key]) return;
      seen[key] = true;
      list.push(v);
    });

    var container = modal.querySelector('.size-options-container');
    if (!container) return;
    container.innerHTML = list.length
      ? '<div class="size-options-wrapper"><div class="size-options size-options-mobile">' +
        list.map(function (v) { return formHtml(productId, v); }).join('') +
        '</div></div>'
      : '<p class="unavailable-message">Produto indisponível</p>';

    modal.hidden = false;
    window.requestAnimationFrame(function () {
      modal.classList.add('show');
      var row = modal.querySelector('.size-options-mobile');
      if (row) row.classList.toggle('has-overflow', row.scrollWidth > row.clientWidth);
    });
  }

  function close() {
    var modal = getModal();
    if (!modal || modal.hidden) return;
    modal.classList.remove('show');
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () { modal.hidden = true; }, 300);
  }

  window.quickAddMobile = { open: open, close: close };

  document.addEventListener('click', function (event) {
    var trigger = closest(event.target, TRIGGER);
    if (trigger && !closest(trigger, '#' + MODAL_ID)) {
      event.preventDefault();
      event.stopPropagation();
      open(trigger);
      return;
    }
    if (closest(event.target, '#' + MODAL_ID + ' [data-close-modal]')) {
      event.preventDefault();
      close();
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') close();
  });

  /* 3) Envio */
  function isQuickAddForm(form) {
    return !!(
      form &&
      form.tagName === 'FORM' &&
      (closest(form, '.quick-add-container') || closest(form, '#' + MODAL_ID))
    );
  }

  // Fecha o modal mobile assim que um tamanho é enviado (o tema abre o carrinho lateral)
  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (isQuickAddForm(form) && closest(form, '#' + MODAL_ID)) {
      setTimeout(close, 250);
    }
  }, true);

  // 15-10: o script do tema ainda não registrou o <product-form>? espera ele (até ms) antes do fallback
  function themeNotReady() {
    return !!(window.customElements && !window.customElements.get('product-form'));
  }
  function waitTheme(ms) {
    return new Promise(function (resolve) {
      var done = false;
      var limit = setTimeout(function () {
        if (done) return;
        done = true;
        resolve(false);
      }, ms);
      window.customElements.whenDefined('product-form').then(function () {
        // um instante para os formulários já na página receberem o listener do tema (upgrade)
        setTimeout(function () {
          if (done) return;
          done = true;
          clearTimeout(limit);
          resolve(true);
        }, 50);
      });
    });
  }
  function resubmit(form, submitter) {
    if (typeof form.requestSubmit === 'function') {
      try {
        if (submitter && submitter.form === form) form.requestSubmit(submitter);
        else form.requestSubmit();
        return;
      } catch (e) {}
    }
    if (submitter) submitter.click();
    else fallbackAdd(form);
  }

  // Rede de segurança: roda por último; só age se o tema NÃO tratou o envio
  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isQuickAddForm(form) || event.defaultPrevented) return;
    event.preventDefault();
    var submitter = event.submitter || form.querySelector('[name="add"]');
    if (!form.__vqaRetried && themeNotReady()) {
      form.__vqaRetried = true;
      setBusy(submitter, true);
      waitTheme(4000).then(function (ready) {
        setBusy(submitter, false);
        if (ready && document.contains(form)) resubmit(form, submitter);
        else fallbackAdd(form);
      });
      return;
    }
    fallbackAdd(form);
  });

  function setBusy(button, busy) {
    if (!button) return;
    button.disabled = busy;
    button.classList.toggle('loading', busy);
    if (busy) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  }

  function fallbackAdd(form) {
    var button = form.querySelector('[name="add"]');
    setBusy(button, true);
    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var d = result.data || {};
          throw new Error(d.description || d.message || 'Não foi possível adicionar ao carrinho.');
        }
        window.location.href = cartUrl();
      })
      .catch(function (error) {
        setBusy(button, false);
        window.alert(error && error.message ? error.message : 'Não foi possível adicionar ao carrinho.');
      });
  }
})();